import moment from 'moment'
import momentTZ from 'moment-timezone';

export class DateUtil {

    static SECONDS_IN_HOUR = 60 * 60;
    static SECONDS_IN_SIX_HOURS = 60 * 60 * 4;
    static SECONDS_IN_DAY = 60 * 60 * 24;
    static SECONDS_IN_WEEK = DateUtil.SECONDS_IN_DAY * 7;

    static MILLISECONDS_IN_MINUTE = 60 * 1000;

    static DEFAULT_TIMEZONE = 'America/Chicago';

    static toDate(date) {
        if (date instanceof Date) {
            return date;
        } else if (typeof date === 'string' || typeof date === 'number') {
            return new Date(date);
        }

        return null;
    }

    static isToday(date) {

        const today = new Date();
        const other = this.toDate(date);

        return other.getFullYear() === today.getFullYear() &&
            other.getMonth() === today.getMonth() &&
            other.getDate() === today.getDate();
    }

    /**
     *
     * @return {number}
     */
    static timestampInMilliseconds() {
        return (new Date()).getTime();
    }

    /**
     *
     * @return {number}
     */
    static timestampInSeconds() {
        let seconds = new Date().getTime() / 1000;
        return Math.ceil(seconds);
    }

    /**
     *
     * @param timestamp
     * @return {boolean}
     */
    static isTimestampInPast(timestamp) {
        let now = this.timestampInSeconds();
        return timestamp < now;
    }

    /**
     *
     * @param {string|number} dateString
     * @returns {string}
     */
    static timeToMdy(dateString) {
        dateString = typeof dateString === 'number' ? dateString : (new Date(dateString));
        return moment(dateString).format("MMM DD, YYYY");
    }

    /**
     *
     * @param {string|number} dateString
     * @returns {string}
     */
    static timeTomdy(dateString) {
        dateString = typeof dateString === 'number' ? dateString : (new Date(dateString));
        return moment(dateString).format("MMM Do, YYYY");
    }

    /**
     * Take date string like "2025-08-06T17:32:12+00:00"
     * and convert it to "Aug 6"
     * @param {string|number} dateString
     * @param appendYearIfNotCurrent
     */
    static dateToAbbreviatedMonthAndDay(dateString, appendYearIfNotCurrent = true) {
        const inputDate = this.toDate(dateString);

        if (!inputDate) {
            return '';
        }

        const today = new Date();

        const options = {
            // year: 'numeric',
            month: 'short',
            day: 'numeric'
        };

        // If date is not in the current calendar year, then also display the year
        if (appendYearIfNotCurrent && inputDate.getFullYear() !== today.getFullYear()) {
            options.year = 'numeric';
        }
        
        return inputDate.toLocaleDateString('en-US', options);
    }

    static formatDateMMMDY(inputDate) {
        if (!inputDate) return '';

        const today = this.parse();
        const input = this.parse(inputDate);
        const formatString = input.year() === today.year() ? 'MMM D' : 'MMM D, YYYY';
        return input.format(formatString);
    }

    // returns POSITIVE number, if date passed it is in the past
    static differenceInSeconds(date) {
        const dateObj = typeof date === 'string' ? (new Date(date)) : date;
        const now = new Date();

        if (dateObj) {
            const diff = now.getTime() - dateObj.getTime();
            return Math.floor(diff / 1000);
        }

        return null;
    }
    static todaysDate() {
        return this.parse().format("YYYY-MM-DD");
    }
    static parse(date) {
        if (!date) {
            return momentTZ().tz(this.DEFAULT_TIMEZONE); // default to "now"
        }
        return momentTZ(date).tz(this.DEFAULT_TIMEZONE);
    }
}
